import { IDayMessageDialog, TimelineNode } from '@jumpstart/core';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { FirebaseHandlers } from '../../../../core/firebase';
import { IMessageInstance } from '../../schema';
import { IConversationPaymentInfo } from './Payments';

const functions = getFunctions();
const textFn: any = httpsCallable(functions, 'messaging-text');
const conversationFn: any = httpsCallable(functions, 'messaging-conversation');


export interface ISendInput {
  uid: string,
  body: string,
  phone: string;
  messageID: string;
  dogDaysOld?: number;
  dialog?: IDayMessageDialog;
  paymentInfo?: IConversationPaymentInfo;
  emblem?: string;
}

export const dateStr = (date: Date): string => `${TimelineNode.month(date.getMonth())}_${date.getDate()}_${date.getFullYear()}`;

export const sendMessage = async (input: ISendInput): Promise<void> => {
  if (input.paymentInfo) {
    console.warn('@TODO remove production override');
    // input.paymentInfo.production = process.env.NODE_ENV === 'production';
    input.paymentInfo.production = false;
  }
  await FirebaseHandlers.run<ISendInput, void>(input, textFn);
};

export const getConversation = async (phone: string): Promise<IMessageInstance[]> => {
  return FirebaseHandlers.run<{phone: string}, IMessageInstance[]>({phone: phone}, conversationFn);
}
